<template>
    <div>
        <el-dialog
                :title="$t('posts.dialog.createFromModelTitle')"
                :visible.sync="modalUseModel"
                width="30%"
                @close="$emit('close-modal-use-model')"
        >
            <span>{{ $t("posts.dialog.createFromModelText") }}</span>
            <br>
            <br>
            <el-input v-model="referenceDuplication"
                      :placeholder="$t('posts.dialog.selectReferencePlaceholder')"
                      :label="$t('posts.dialog.selectReference')"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button @click="SET_MODAL_USE_MODEL(false)">{{ $t("posts.dialog.cancel") }}</el-button>
                <el-button type="primary" @click="$emit('dupliquer-annonce', {'reference' : referenceDuplication})">{{ $t("posts.dialog.confirm") }}</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import ElButton from '../../../../components/Button'

export default {
  name: 'DialogUseModel',
  components: {
    ElButton
  },
  data () {
    return {
      referenceDuplication: null
    }
  },
  computed: {
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    ...mapGetters('dialogsPostsListImmo', ['modalUseModel']),
    userFilter () {
      return this.filter.user
    }
  },
  methods: {
    ...mapMutations('dialogsPostsListImmo', ['SET_MODAL_USE_MODEL'])
  },
  beforeMount () {

  }
}

</script>
